// Magnetomotive Force units with conversion factors to ampere-turn (At)
export const magnetomotiveForceUnits = [
  { id: 'ampere-turn', name: 'Ampere-turn', symbol: 'At', plural: 'Ampere-turns', factor: 1 },
  { id: 'kiloampere-turn', name: 'Kiloampere-turn', symbol: 'kAt', plural: 'Kiloampere-turns', factor: 1e3 },
  { id: 'milliampere-turn', name: 'Milliampere-turn', symbol: 'mAt', plural: 'Milliampere-turns', factor: 1e-3 },
  { id: 'gilbert', name: 'Gilbert', symbol: 'Gi', plural: 'Gilberts', factor: 0.795774715 },
];

export const popularMagnetomotiveForceConversions = [
  { from: 'ampere-turn', to: 'gilbert' },
  { from: 'gilbert', to: 'ampere-turn' },
  { from: 'ampere-turn', to: 'kiloampere-turn' },
  { from: 'kiloampere-turn', to: 'ampere-turn' },
];

export const getUnitById = (id) => magnetomotiveForceUnits.find(unit => unit.id === id);

export const convertMagnetomotiveForce = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert magnetomotive force units and learn the conversion formula.`;
};
